import * as constants from './config/constants.js';
import Selectors from './utils/selectors.js';
import ResponseHandler from './utils/response-handler.js';
import RequestHandler from './utils/request-handler.js';

export default class Voucher {
    constructor() {
        this.dataIdentifier = 'data-voucher';
        this.elementIdentifier = 'voucher';
        this.addFormIdentifier = 'add_form';
        this.voucherResponseMessage = this.elementIdentifier + '_response_message';
        this.responseHandler = new ResponseHandler;
        this.requestHandler = new RequestHandler;
        this.basketItemIdentifier = 'basket_item_';
        this.basketItemVoucherApplied = 'basket_item_voucher_applied';
        this.basketItemPricing = 'basket_item_pricing';
        this.basketTotals = 'basket_totals';
        this.selectors = new Selectors({
            dataAttrId: this.dataIdentifier
        });
    }

    setup() {
        this.setupFormListener();
    }

    setupFormListener() {
        document.addEventListener('submit', (event) => {
            let formElement = event.target;
            if (!formElement.hasAttribute(this.dataIdentifier)) {
                return;
            }
            event.preventDefault();

            let data = {};
            if (formElement.getAttribute(this.dataIdentifier) == this.addFormIdentifier) {
                data = {
                    'voucherCode': formElement.querySelector(this.selectors.nameAttr('voucherCode')).value
                };
            }
            this.requestHandler.post(
                formElement.action,
                data,
                this.updateVoucherCallback.bind(this)
            );
        });
    }

    updateVoucherCallback(response) {
        let alertElement = document.querySelector(this.selectors.dataAttr(this.voucherResponseMessage));
        alertElement.innerText = response.message;
        alertElement.classList.remove(constants.ALERT_ERROR_CLASS, constants.ALERT_SUCCESS_CLASS);
        alertElement.classList.add(constants.ALERT_CLASS);

        if (response.result !== 'success') {
            alertElement.classList.add(constants.ALERT_ERROR_CLASS);
            return;
        }

        let basketItem = document.querySelector(this.selectors.dataAttr(this.basketItemIdentifier + response.basketItemId));

        alertElement.classList.add(constants.ALERT_SUCCESS_CLASS);

        basketItem.querySelector(this.selectors.dataAttr(this.basketItemVoucherApplied)).innerHTML = response.VoucherAppliedHtml;
        basketItem.querySelector(this.selectors.dataAttr(this.basketItemPricing)).innerHTML = response.basketItemPricing;

        document.querySelector(this.selectors.dataAttr(this.basketTotals)).innerHTML = response.basketTotalsHtml;
    }
}
